"use client";

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopDepok: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kenapa Sewa Laptop Depok Bukan Pilihan, Tapi Keputusan Bisnis</h2>

    <h3 className="text-lg font-semibold mb-2">
      Sewa Laptop Depok Fleksibel untuk Mahasiswa, Pebisnis, Freelance & Konten Kreator
    </h3>

    <p className="mb-4">
      Di tengah kota pelajar seperti Depok, kebutuhan perangkat kerja makin menggila. Harga laptop makin mahal, spek makin menuntut, dan siklus upgrade makin cepat. Tapi, beli untuk dipakai sesekali? Mubazir. <strong>Sewa laptop Depok</strong> bukan sekadar solusi alternatif, ini strategi.
    </p>

    <p className="mb-4">
      Dari UI sampai Cibubur, dari freelance desain sampai UMKM digital, <strong>sewa laptop Depok</strong> adalah cara cerdas menghindari aset mati, tanpa kehilangan performa kerja. Hemat, siap pakai, dan penuh support.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Distribusi Cepat di Seluruh Depok</h4>
        <p className="text-sm">
          Dengan titik distribusi strategis di area kampus, bisnis, dan perumahan, kami pastikan pengiriman <strong>sewa laptop Depok</strong> cepat² tanpa drama. Dari UI, Sawangan, Pancoran Mas, Beji hingga Citayam, kami siap gerak.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Unit Laptop Siap Tempur</h4>
        <p className="text-sm">
          Semua <strong>laptop sewaan Depok</strong> kami pakai spek kekinian, SSD, RAM minimal 8GB, prosesor i5 atau Ryzen series. Bisa request brand seperti Lenovo, Asus, HP, Dell. Office & software siap pakai, kamu tinggal kerja.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Harga Sewa Laptop Depok Transparan</h4>
        <p className="text-sm">
          Semua harga sewa sudah termasuk gratis ongkir untuk area Depok utama. Kami nggak pakai biaya² tersembunyi. Pinggiran seperti Bojongsari atau Citayam bisa disesuaikan, semua dikomunikasikan di awal.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Support Teknisi Real-Time</h4>
        <p className="text-sm">
          Kalau laptop freeze saat Zoom, atau error saat presentasi? Langsung hubungi tim kami. <strong>Sewa laptop Depok</strong> dari kami dilengkapi dengan teknisi stand by, bahkan ganti unit on the spot.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h4 className="font-semibold text-lg mb-2">Durasi Sewa Bebas Atur</h4>
        <p className="text-sm">
          Harian, mingguan, bulanan, atau bahkan custom durasi proyek? Semua bisa. <strong>Sewa laptop Depok</strong> dirancang untuk fleksibilitas maksimal, harga makin hemat jika makin lama.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Layanan Antar Jemput Tanpa Drama</h2>
    <p className="mb-4">
      Kami paham waktumu mahal. Karena itu, kami kirim langsung ke rumah, kampus, coworking, hingga kafe tempat kamu kerja. <strong>Sewa laptop Depok</strong> harusnya simpel. Tanpa repot. Kami antar-jemput dengan sopan dan cepat.
    </p>

    <h2 className="text-xl font-bold mb-3">Sewa Laptop Depok Full Maintenance</h2>
    <p className="mb-4">
      Selama masa sewa, kamu nggak sendirian. Butuh install software? Reset akun? Ganti charger? <strong>Layanan sewa laptop di Depok</strong> kami sudah termasuk bantuan teknis sampai masa kontrak selesai.
    </p>

    <h2 className="text-xl font-bold mb-3">Khusus Mahasiswa & Pebisnis Muda</h2>
    <p className="mb-4">
      Kamu butuh performa tinggi tapi budget terbatas? Nego harga? Boleh. <strong>Sewa laptop Depok</strong> cocok buat kamu yang sedang bangun portofolio, startup, atau riset akhir semester.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Laptop" />
  </>
);

export default laptopDepok;